/* 🤖 this file was generated by svg-to-ts */
export const emperorIconFileBlock2: {
  name: 'file_block_2';
  data: string;
} = {
  name: 'file_block_2',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M4 9h8v2H4Z"/><path d="M4 13h6v2H4Z"/><path d="M2 2h10v4h4v4h2V4.586L13.414 0H2C.897 0 0 .898 0 2v18c0 1.1.897 2 2 2h8v-2H2V2Z"/><path d="M18 12c-3.31 0-6 2.69-6 6 0 3.3 2.69 6 6 6 3.3 0 6-2.7 6-6 0-3.31-2.7-6-6-6Zm-4 6c0-2.21 1.795-4 4-4 .73 0 1.42.21 2.02.56l-5.46 5.45c-.36-.6-.57-1.28-.57-2.02Zm4 4c-.74 0-1.43-.22-2.02-.57l5.45-5.452c.35.59.56 1.28.56 2.019 0 2.2-1.8 4-4 4Z"/></g></svg>`,
};
